/**
 * @generated SignedSource<<5563d8228fefb48750f5aba07a5cd337>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useInitGroupEvent_event$data = {
  readonly allowedGroupSizes: ReadonlyArray<number | null | undefined>;
  readonly maxGuestCount: number;
  readonly maxMemberCount: number;
  readonly minGuestCount: number;
  readonly minMemberCount: number;
  readonly " $fragmentType": "useInitGroupEvent_event";
};
export type useInitGroupEvent_event$key = {
  readonly " $data"?: useInitGroupEvent_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitGroupEvent_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitGroupEvent_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowedGroupSizes",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "7eab06ced4c4944ec7eff2644eb6cadf";

export default node;
